<template>
    <div v-if="isOpen" class="fixed inset-0 top-[-1rem] bg-black bg-opacity-50 flex items-center justify-center z-50 w-full h-full p-8">
      <div class="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative dark:bg-dark-box-bg dark:border dark:border-dark-border dark:text-dark-text max-h-[90vh] overflow-y-auto" ref="modal" :style="modalStyle">
        <!-- <h2 class="text-2xl font-bold mb-4 text-gray-800 dark:text-dark-text">Stwórz Dyspozytora</h2> -->
        <div 
          class="cursor-move mb-4 pb-2 border-b dark:border-dark-border"
          @mousedown="startDrag"
          @touchstart="startDrag"
        >
          <h2 class="text-2xl font-bold text-gray-800 dark:text-dark-text">Stwórz Dyspozytora</h2>
        </div>
        <button @click="closeModal" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 focus:outline-none dark:text-dark-text dark:hover:text-dark-border-hover">
          <span class="text-xl">&times;</span>
        </button>
        <form @submit.prevent="submitForm" class="space-y-4">
          <!-- Imię -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Imię <span class="text-red-600">(*)</span>:</label>
            <input
                v-model="localDispatcher.firstName"
                type="text"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.firstName }"
                @input="validateField('firstName')"
            />
            <span v-if="localErrors.firstName" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.firstName }}</span>
          </div>
  
          <!-- Nazwisko -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Nazwisko <span class="text-red-600">(*)</span>:</label>
            <input
                v-model="localDispatcher.lastName"
                type="text"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.lastName }"
                @input="validateField('lastName')"
            />
            <span v-if="localErrors.lastName" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.lastName }}</span>
          </div>

          <!-- Numer Telefonu -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Numer Telefonu <span class="text-red-600">(*)</span>:</label>
            <input
                v-model="localDispatcher.phone"
                type="number"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.phone }"
                @input="validateField('phone')"
            />
            <span v-if="localErrors.phone" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.phone }}</span>
          </div>
  
          <!-- Rola -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Rola <span class="text-red-600">(*)</span>:</label>
            <select
                v-model="localDispatcher.role.name"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.roleName }"
                @change="validateField('roleName')"
            >
              <option value="">Wybierz rolę</option>
              <option value="ROLE_YOUNG_DISPATCHER">Młodszy Dyspozytor</option>
              <option value="ROLE_ADULT_DISPATCHER">Starszy Dyspozytor</option>
            </select>
            <span v-if="localErrors.roleName" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.roleName }}</span>
          </div>
  
          <!-- Submit -->
          <div class="flex justify-end">
            <button 
                type="submit"
                :disabled="!isFormValid || isSubmitting"
                class="w-full bg-button-bg text-button-text py-2 rounded-md hover:bg-button-hover focus:outline-none focus:ring focus:ring-indigo-500 dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
                :class="{ 'opacity-50 cursor-not-allowed': !isFormValid || isSubmitting }"
            >
              Stwórz Dyspozytora
            </button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      isOpen: Boolean,
      errors: Object
    },
    data() {
      return {
        localDispatcher: {
          firstName: '',
          lastName: '',
          phone: '',
          role: {
            name: ''
          }
        },
        localErrors: {
          firstName: '',
          lastName: '',
          phone: '',
          roleName: ''
        },
        isSubmitting: false,
        isDragging: false,
        dragOffset: { x: 0, y: 0 },
        modalPosition: { x: 0, y: 0 }
      };
    },
    computed: {
      isFormValid() {
        // Sprawdza, czy wszystkie błędy są puste
        const noErrors = Object.values(this.localErrors).every(error => error === '');
        
        // Sprawdza, czy wszystkie wymagane pola są wypełnione
        const allFieldsFilled = this.localDispatcher.firstName &&
                                this.localDispatcher.lastName &&
                                this.localDispatcher.phone &&
                                this.localDispatcher.role.name;
        
        return noErrors && allFieldsFilled;
      },
      modalStyle() {
        return {
          transform: `translate(${this.modalPosition.x}px, ${this.modalPosition.y}px)`
        };
      }
    },
    methods: {
      validateField(field) {
        switch (field) {
            case 'firstName':
                this.localErrors.firstName = !this.localDispatcher.firstName ? 'Imię jest wymagane' : '';
                break;
            case 'lastName':
                this.localErrors.lastName = !this.localDispatcher.lastName ? 'Nazwisko jest wymagane' : '';
                break;
            case 'phone':
                this.localErrors.phone = !this.localDispatcher.phone ? 'Numer telefonu jest wymagany' : '';
                break;
            case 'roleName':
                this.localErrors.roleName = !this.localDispatcher.role.name ? 'Rola jest wymagana' : '';
                break;
        }
      },
      closeModal() {
        this.$emit('close');
      },
      async submitForm() {
        if (this.isSubmitting) return;
  
        this.isSubmitting = true;
  
        // Validate all fields
        this.validateField('firstName');
        this.validateField('lastName');
        this.validateField('phone');
        this.validateField('roleName');
  
        if (!Object.values(this.localErrors).some(error => error !== '')) {
          this.$emit('submit', this.localDispatcher);
        } else {
          console.log('Please correct the errors in the form before submitting.');
        }
  
        this.localDispatcher = {
          firstName: '',
          lastName: '',
          phone: '',
          role: {
            name: ''
          }
        };
        this.localErrors = {
          firstName: '',
          lastName: '',
          phone: '',
          roleName: ''
        };

        this.isSubmitting = false;
      },
      startDrag(event) {
        this.isDragging = true;
        
        event.currentTarget.classList.add('dragging');

        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.dragOffset.x = clientX - this.modalPosition.x;
        this.dragOffset.y = clientY - this.modalPosition.y;
        
        // Dodajemy event listeners
        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('touchmove', this.onDrag, { passive: false });
        document.addEventListener('mouseup', this.stopDrag);
        document.addEventListener('touchend', this.stopDrag);
      },
      onDrag(event) {
        if (!this.isDragging) return;
        
        event.preventDefault();
        
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.modalPosition.x = clientX - this.dragOffset.x;
        this.modalPosition.y = clientY - this.dragOffset.y;
      },
      stopDrag() {
        this.isDragging = false;
        
        const dragElement = document.querySelector('.cursor-move');
        if (dragElement) {
          dragElement.classList.remove('dragging');
        }

        // Usuwamy event listeners
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('touchmove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('touchend', this.stopDrag);
      },
      resetPosition() {
        this.modalPosition = { x: 0, y: 0 };
      },
    }
  };
  </script>
  
<style scoped>
.cursor-move {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.dragging {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>
  